<script lang="ts">
    import { ADDRESS_INFO_LOGO } from '../constants/imgList';

    import webp from '@/actions/webp';
    import { CREDIT_CARD_CAT, CREDIT_CARD_ADDRESS } from '@/configs/compliance';

    export let isWhiteBackground = false;
    export let catText = CREDIT_CARD_CAT.CARD_COMMON;
</script>

<div class="address-info" class:white-background={isWhiteBackground}>
    <div class="top-title">
        {catText}
        <div class="line"></div>
        {CREDIT_CARD_ADDRESS}
    </div>
    <div class="bottom-logo">
        <img
            class="img"
            use:webp
            src={ADDRESS_INFO_LOGO}
            alt=""
            loading="lazy"
            decoding="async"
        />
    </div>
</div>

<style lang="scss">
    .address-info {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px 56px;
        background-color: #ffffff;
        margin-top: 0.4rem;
        color: #474747;
    }

    .address-info.white-background {
        background-color: #f5f5f7;
        margin-top: 0;
    }

    .top-title {
        width: 100%;
        box-sizing: border-box;
        font-family: DiDiSans-Pro-Regular;
        font-size: 20px;
        line-height: 32px;
        text-align: center;
        letter-spacing: normal;
        opacity: 0.6;
    }

    .top-title .line {
        height: 16px;
    }

    .bottom-logo {
        margin-top: 16px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .img {
        width: 195px;
        height: 36px;
    }
</style>
